import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
const reactPlugin = new ReactPlugin()
//const instrumentationKey = process.env.REACT_APP_INSTRUMENTATION_KEY;
const appInsights = new ApplicationInsights({
  config: {
      instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY, // Ensure this is set
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      // extensionConfig: {
        //[reactPlugin.identifier]: { history: window.history }
      //}
  }
  
});
appInsights.trackPageView();
appInsights.trackException();
appInsights.trackEvent();
  appInsights.loadAppInsights();
export {reactPlugin,appInsights};